import { customers } from './customers';
import { encoderProfiles } from './encoder-profiles';
import { encoders } from './encoders';
import { monitors } from './monitors';
import { onboarding } from './onboarding';
import { plans } from './plans';
import { streamProfiles } from './stream-profiles';
import { timezones } from './timezones';
import { userPlans } from './user-plans';
import { users } from './users';
import { userSearch } from './user-search';
import { webPlans } from './web-plans';

export const v2 = {
  customers,
  encoders,
  encoderProfiles,
  monitors,
  onboarding,
  plans,
  streamProfiles,
  timezones,
  userPlans,
  users,
  userSearch,
  webPlans,
};
